import { useUser } from '@/context/userContext';
import { Navigate, Outlet } from 'react-router';
import { getNotFoundPath } from '@/bundle/pages/NotFoundPage/path';
import { hasBillingSubscription, isStandardPlanType } from '@/helpers/billingHelpers';

export const BillingPageProtectedRoute = () => {
  const { user } = useUser();
  const isStandardPlan = isStandardPlanType(user);
  const hasSubscription = hasBillingSubscription(user);

  // Only show billing page users with subscription and standard plan
  if (isStandardPlan && hasSubscription) {
    return <Outlet />;
  }

  return <Navigate to={getNotFoundPath()} />;
};
